import { Component, OnInit } from '@angular/core';
import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService, ModalService, QueryParameter, ModelDataService, ConfigService, CompanyData, CommonService, CompanyDataService, UserRightsService } from 'yt-ng-framework';
import { Izvod } from './izvod';
import { ActivatedRoute } from '@angular/router';
// import * as Convert  from 'xml-js';
import { List } from 'immutable';
import { UvozIzvoda } from './uvoz-izvoda';
import { switchMap, map, retry } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Dokument } from './TrezorIzvod/dokument';
import { Stmtrslist } from './OfficeBankingIzvod/Stmtrslist';
import { Halcom } from './HalcomIzvod/halcom';
import { OrgJed } from 'src/app/lookups/orgjed/orgjed';
import { XMLParser } from 'fast-xml-parser';
// import xml  = require('xml-js');

// const xml2json = xml;
 
@Component({
  selector: 'yt-izvod-tab-update',
  templateUrl: './izvod-tab-update.component.html'
})

export class IzvodTabUpdateComponent extends BaseTabsUpdateComponent<Izvod> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<Izvod>,
    protected baseDataService: BaseDataService,
    protected userService: UserService,
    protected modalService: ModalService,
    protected modelDataService: ModelDataService,
    protected configService: ConfigService,
    protected commonService: CommonService,
    protected companyDataService : CompanyDataService,
    protected userRightsService: UserRightsService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }
 
  _rb: number;
  _ziroRacunFirme: string;
  _ziroRacunKomitenta;
  _komitentID: number;
  _komitentNaziv: string;
  _brojFakture: string;
  _duguje :number;
  _potrazuje: number;
  _opis: string;
  _orgJedID: number = null;
  _pozivNaBrojOdobrenja: string;
  _sifraPlacanja: string;
  uvozIzvodaList : List<UvozIzvoda> = List([]);
  items = [];
  loading : boolean = false;
  orgJedItems = [];
  hasUserRightsUvozIzvoda: boolean;
  // orgJedID: number = 0;

  ngOnInit() {
    super.ngOnInit();
    this.baseDataService.Get("orgjed","getParentAndChildByParentID",null,OrgJed,null)
      .subscribe((data)=>{
        this.orgJedItems = data;
        if (this.orgJedItems.length == 1)
          this._orgJedID = Number(this.orgJedItems[0]["ID"]);
      })

    this.hasUserRightsUvozIzvoda = this.userRightsService.GetUserRightValue(this.modelData.MainList.UserRightsModelName, "uvozIzvoda");
    this.defaultUpdateButtons.ButtonsConfig.SaveButtonConfig.Visible = false;
    this.defaultUpdateButtons.ButtonsConfig.ResetButtonConfig.Visible = false;

    this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.ItemSaved
    .subscribe((value)=>{
      if (value){
        let idParameter = [new QueryParameter("id", this.baseUpdateComponent.Item.ID)];
        this.baseDataService.Get(this.baseUpdateComponent.modelData.MainList.ModelName,
            "GetViewItemByID",
            idParameter,
            this.baseUpdateComponent.modelData.MainList.ShortModelClass)
            .subscribe((data:any)=>{
            // ovo utiče na osvežavanje tabele za dokumenta na pregledu. Osvežava MainItems
            this.tabsContainerService.EmitItem(data);
            })
      }
    })
    
  }

  UvozIzvoda(){
    let input = document.createElement('input');
    input.type = 'file';
    input.accept=".txt, .xml";
    let _mainThis = this;
    input.onchange = function(e: Event) {              
              var file = (<HTMLInputElement>e.target).files[0]; 
              // console.log(file);
              var reader:FileReader = new FileReader();
              // reader.readAsText(file,'UTF-8');
              reader.readAsText(file,'windows-1250');

              reader.onload = async _ => {
                var content =  reader.result; // this is the content!
                if (content){
                  _mainThis.loading = true;
                  let _modelData = _mainThis.modelDataService.GetModelDataByPath("uvoz-izvoda");
                  let orgJedConfig = {
                    modelName: 'orgjed',
                    getName: 'getParentAndChildByParentID',
                    modelProperty: 'Naziv',
                    orderBy: 'Naziv',
                    formControlName: 'OrgJedID',
                    label: 'UVOZIZVODA.ORGJED.SINGULAR',
                    width: 'xl',
                    position: 'left'
                  }

                  let komitentConfig = {
                    modelName: 'komitent',
                    getName: 'get',
                    modelProperty: 'SNaziv,Mesto',
                    orderBy: 'SNaziv',
                    formControlName: 'KomitentID',
                    label: 'UVOZIZVODA.KOMITENT.SINGULAR',
                    allowAddNew: 'true',
                    allowEdit: 'true',
                    width: 'xxl',
                    position: 'left'
                  }

                  let ziroRacunConfig = {
                    formControlName: 'ZiroRacunKomitenta',
                    label: 'UVOZIZVODA.ZIRORACUNKOMITENTA.SINGULAR'
                  }

                  let rbConfig = {
                    name: 'rb',
                    formatString: '1.0-0',
                    formControlName: 'RB',
                    label: 'UVOZIZVODA.RB.SINGULAR'
                  }

                  let brojFaktureConfig = {
                    formControlName: 'BrojFakture',
                    label: 'UVOZIZVODA.BROJFAKTURE.SINGULAR',
                    maxLength: '20'
                  }

                  let dugujeConfig = {
                    name: 'duguje',
                    formatString: '1.2-2',
                    formControlName: 'Duguje',
                    label: 'UVOZIZVODA.DUGUJE.SINGULAR'
                  }

                  let potrazujeConfig = {
                    name: 'potrazuje',
                    formatString: '1.2-2',
                    formControlName: 'Potrazuje',
                    label: 'UVOZIZVODA.POTRAZUJE.SINGULAR'
                  }

                  let gridConfig = [
                    {name: 'RB', label: 'UVOZIZVODA.RB.SINGULAR', type: 'number', config: rbConfig, disabled: false, color: '#dee2e6', format: '1.2-2', required : 'true', width:'8%'}
                    ,{name: 'ZiroRacunKomitenta', label: 'UVOZIZVODA.ZIRORACUN.SINGULAR', type: 'input', config: ziroRacunConfig, disabled: true, required : 'true', width:'17%'}
                    ,{name: 'KomitentID', label: 'UVOZIZVODA.KOMITENT.SINGULAR', type: 'DDL', config: komitentConfig, disabled: false, color: '#dee2e6', required : 'true', width:'20%'}
                    ,{name: 'BrojFakture', label: 'UVOZIZVODA.BROJFAKTURE.SINGULAR', type: 'input', config: brojFaktureConfig, disabled: false, width:'15%'}
                    ,{name: 'Duguje', label: 'UVOZIZVODA.DUGUJE.SINGULAR', type: 'number', config: dugujeConfig, disabled: true, width:'10%'}
                    ,{name: 'Potrazuje', label: 'UVOZIZVODA.POTRAZUJE.SINGULAR', type: 'number', config: potrazujeConfig, disabled: true, width:'10%'}
                    ,{name: 'OrgJedID', label: 'UVOZIZVODA.ORGJED.SINGULAR', type: 'DDL', config: orgJedConfig, disabled: false, color:'#dee2e6', required: 'true', width:'20%'}    
                  ];

                  // let gridConfig = [
                  //   {name: 'RB', label: 'Red. broj', type: 'number', config: rbConfig, disabled: false, color: '#3AAB58', format: '1.2-2', required : 'true', width:'5%'}
                  //   ,{name: 'ZiroRacunKomitenta', label: 'Žiro-račun', type: 'input', config: ziroRacunConfig, disabled: true, required : 'true', width:'17%'}
                  //   ,{name: 'KomitentID', label: 'Komitent', type: 'DDL', config: komitentConfig, disabled: false, color: '#3AAB58', required : 'true', width:'20%'}
                  //   ,{name: 'BrojFakture', label: 'Broj fakture', type: 'input', config: brojFaktureConfig, disabled: false, color: '#3AAB58', required : 'true', width:'15%'}
                  //   ,{name: 'Duguje', label: 'Duguje', type: 'number', config: dugujeConfig, disabled: true, width:'12.5%'}
                  //   ,{name: 'Potrazuje', label: 'Potražuje', type: 'number', config: potrazujeConfig, disabled: true, width:'12.5%'}
                  //   ,{name: 'OrgJedID', label: 'Org. jedinica', type: 'DDL', config: orgJedConfig, disabled: false, color:'#3AAB58', required: 'true', width:'18%'}    
                  // ];

                  let gridParameter = new QueryParameter("grid",gridConfig);

                  let uvozIzvoda : List<UvozIzvoda>;

                  if (file.type == "text/xml"){
                    // console.log('1. xml fajl spreman za parsiranje.')
                    // parseXmlFile(content.toString(), _mainThis)
                    //   .pipe(map(result => {
                    //     uvozIzvoda = result;
                    //   }));
                    uvozIzvoda = parseXmlFile(content.toString(), _mainThis);
                    if (uvozIzvoda.size != 0){
                      for (let i = 0; i < uvozIzvoda.size; i++){
                        await new Promise<void>((resolve, reject) =>{
                        GetCustomerIDByAccountNumber(uvozIzvoda.get(i).ZiroRacunKomitenta, _mainThis)
                          .subscribe(result => {
                            if (result)
                              uvozIzvoda.get(i).KomitentID = result;
                            else{
                              GetCustomerTaxIDNOByAccountNumberFromNBS(uvozIzvoda.get(i).ZiroRacunKomitenta, _mainThis)
                                .subscribe(result => {
                                  if(result["value"] != undefined){
                                    GetCustomerIDByTaxIDNO(result, _mainThis)
                                      .subscribe(result =>{
                                        if (result)
                                          uvozIzvoda.get(i).KomitentID = result;
                                      })
                                  }
                                  // uvozIzvoda.get(i).KomitentID = result;
                                });
                            }
                            resolve();
                        });
                        
                      })
                      }
                    }
                    let uvozIzvodaParameter = new QueryParameter("uvozIzvoda",uvozIzvoda);
                    _mainThis.loading = false;
                    _mainThis.modalService.ShowModal(0,_modelData,null,true,[uvozIzvodaParameter, gridParameter])
                    .result
                    .then((item)=>{  
                      _mainThis.baseUpdateComponent.baseInlineContainer.baseDetailList.RefreshData();
      
                    }, (reason) => {
                
                    })  
                  }
                  else if(file.type == "text/plain"){
                    uvozIzvoda = UvozHalcomIzvoda(content.toString(), _mainThis);
                    if (uvozIzvoda.size != 0){
                      for (let i = 0; i < uvozIzvoda.size; i++){
                        await new Promise<void>((resolve, reject) =>{
                        GetCustomerIDByAccountNumber(uvozIzvoda.get(i).ZiroRacunKomitenta, _mainThis)
                          .subscribe(result => {
                            if (result)
                              uvozIzvoda.get(i).KomitentID = result;
                            else{
                              GetCustomerTaxIDNOByAccountNumberFromNBS(uvozIzvoda.get(i).ZiroRacunKomitenta, _mainThis)
                                .subscribe(result => {
                                  if(result["value"] != undefined){
                                    GetCustomerIDByTaxIDNO(result, _mainThis)
                                      .subscribe(result =>{
                                        if (result)
                                          uvozIzvoda.get(i).KomitentID = result;
                                      })
                                  }
                                  // uvozIzvoda.get(i).KomitentID = result;
                                });
                            }
                            resolve();
                        });
                        
                      })
                      }
                    }
                    let uvozIzvodaParameter = new QueryParameter("uvozIzvoda",uvozIzvoda);
                    _mainThis.loading = false;
                    _mainThis.modalService.ShowModal(0,_modelData,null,true,[uvozIzvodaParameter, gridParameter])
                    .result
                    .then((item)=>{     
                      _mainThis.baseUpdateComponent.baseInlineContainer.baseDetailList.RefreshData();
                    }, (reason) => {
                
                    })  
                  }
                  else
                    return false;
                }
             }
          };
    input.click();
  }
 
 
}

function UvozHalcomIzvoda(content: string, mainThis: any){
  var lines = content.toString().split('\n');
  var tarabe = lines[0].split('#');
  if (tarabe.length == 1)
    return false;
  let sadrzaj: Halcom;
  let dokument: Halcom[] = [];
  for(var line = 1; line < lines.length; line++){      
      if (lines[line] != ""){
        sadrzaj = new Halcom().Deserialize(tarabe, lines[line]);
        dokument.push(sadrzaj);
      }
  }
  mainThis.uvozIzvodaList = List([]);
  
  let brojvirmana = dokument.length;

  for(var i=0; i< brojvirmana; i++){
    var uvozIzvoda : UvozIzvoda = new UvozIzvoda();
    mainThis._rb=i+1;
    mainThis._ziroRacunFirme=dokument[i].RacunZaduzenja;
    mainThis._ziroRacunKomitenta = dokument[i].RacunOdobrenja;
    mainThis._brojFakture = dokument[i].PozivNaBrojOdobrenja;
    mainThis._pozivNaBrojOdobrenja = dokument[i].PozivNaBrojOdobrenja;
    mainThis._sifraPlacanja = dokument[i].SifraPlacanja;
    mainThis._opis = dokument[i].Svrha;;
    mainThis._duguje = dokument[i].Duguje;
    mainThis._potrazuje = dokument[i].Potrazuje;
    //mainThis._duguje = 0;
    //mainThis._potrazuje = 0;
    
    upisiUListu(mainThis);
  }
   return mainThis.uvozIzvodaList;
}

function UvozTrezorIzvoda(js_obj:any, mainThis:any){

  let dokument: Dokument;
  dokument = new Dokument().Deserialize(js_obj);

  mainThis.uvozIzvodaList = List([]);

  mainThis._ziroRacunFirme=dokument.Zbirni.RacunIzvoda;
  let brojvirmana = dokument.Stavka.length;

  for(var i=0; i< brojvirmana; i++){
    mainThis._rb=i+1;
    mainThis._ziroRacunKomitenta = dokument.Stavka[i].RacunOdobrenja;
    mainThis._brojFakture = dokument.Stavka[i].PozivOdobrenja;
    mainThis._pozivNaBrojOdobrenja = dokument.Stavka[i].PozivOdobrenja;
    mainThis._sifraPlacanja = dokument.Stavka[i].SifraPlacanja;
    mainThis._opis = dokument.Stavka[i].SvrhaDoznake;
    mainThis._duguje = 0;
    mainThis._potrazuje = 0;

    if (mainThis._ziroRacunFirme == dokument.Stavka[i].RacunZaduzenja)
      mainThis._duguje = dokument.Stavka[i].Iznos;
    else
      mainThis._potrazuje = dokument.Stavka[i].Iznos;

    upisiUListu(mainThis);
 }

  return mainThis.uvozIzvodaList;

}

function UvozPeximIzvoda(js_obj:any, mainThis:any){
  // console.log('3. ulazak za pexim')
  let dokument: Stmtrslist;
  dokument = new Stmtrslist().Deserialize(js_obj);

  mainThis.uvozIzvodaList = List([]);

  mainThis._ziroRacunFirme=dokument.Stmtrs.Acctid;
  let brojvirmana = dokument.Stmtrs.Trnlist.length;

  for(var i=0; i< brojvirmana; i++){
    // console.log('4. for petlja '+ i);
    
    mainThis._rb=i+1;
    mainThis._ziroRacunKomitenta = dokument.Stmtrs.Trnlist[i].Stmttrn.Payeeaccountinfo.Acctid;
    mainThis._brojFakture = dokument.Stmtrs.Trnlist[i].Stmttrn.Payeerefnumber;
    mainThis._pozivNaBrojOdobrenja = dokument.Stmtrs.Trnlist[i].Stmttrn.Payeerefnumber;
    mainThis._sifraPlacanja = dokument.Stmtrs.Trnlist[i].Stmttrn.Purposecode;
    mainThis._opis = dokument.Stmtrs.Trnlist[i].Stmttrn.Purpose;
    mainThis._duguje = 0;
    mainThis._potrazuje = 0;
    if (dokument.Stmtrs.Trnlist[i].Stmttrn.Benefit != 'credit')
      mainThis._duguje = dokument.Stmtrs.Trnlist[i].Stmttrn.Trnamt;
    else
      mainThis._potrazuje = dokument.Stmtrs.Trnlist[i].Stmttrn.Trnamt;

    // console.log('5. pre upisa u listu')
    upisiUListu(mainThis);
  }
   return mainThis.uvozIzvodaList;

}

function upisiUListu(mainThis:any){
  // console.log('6. upis u listu');
  var uvozIzvoda : UvozIzvoda = new UvozIzvoda();
  uvozIzvoda.IzvodID = mainThis.baseUpdateComponent.Item.ID;
  uvozIzvoda.RB = mainThis._rb;
  uvozIzvoda.ZiroRacunFirme = mainThis._ziroRacunFirme;
  uvozIzvoda.ZiroRacunKomitenta = mainThis._ziroRacunKomitenta;
  uvozIzvoda.BrojFakture = mainThis._brojFakture;
  uvozIzvoda.PozivNaBrojOdobrenja = mainThis._pozivNaBrojOdobrenja;
  uvozIzvoda.Opis = mainThis._opis;
  uvozIzvoda.Duguje = mainThis._duguje;
  uvozIzvoda.Potrazuje = mainThis._potrazuje;
  uvozIzvoda.SifraPlacanja = mainThis._sifraPlacanja;
  uvozIzvoda.OrgJedID = mainThis._orgJedID;
  //pronadji komitenta
  // console.log('7. pre pronađi komitenta')
 
  mainThis.uvozIzvodaList = mainThis.uvozIzvodaList.push(uvozIzvoda);
}

function parseXmlFile(content: string, mainThis:any){ 
  // console.log('2. ulazak za parsiranje');
  // var option = {compact: true, spaces: 4};
  var jsonResult;
  // jsonResult = Convert.xml2json(content, option);

  const parser = new XMLParser({
    ignoreAttributes: false,
    attributeNamePrefix: '@_', // možeš i '' ako ne želiš prefiks
  });
  const jsonObject = parser.parse(content);
  jsonResult = JSON.stringify(jsonObject, null, 4);
  // console.log(jsonResult);
  let js_obj = JSON.parse(jsonResult);

  if (js_obj.Dokument != undefined)
    return UvozTrezorIzvoda(js_obj, mainThis);
  else
    return UvozPeximIzvoda(js_obj, mainThis)

}

function GetCustomerIDByAccountNumber(accountNumber:string, mainThis:any):Observable<number>{
  // console.log('8. pronađi komitenta')
  let _bankCode : string;
  let _accountNumber : string;
  let _controlNumber: string;
  let _fullAccountNumber: string;
  let komitentId: number;
  accountNumber = accountNumber.replace(/-/g,'');

  _bankCode = accountNumber.substr(0,3);
  _accountNumber = new CommonService().PadLeft(accountNumber.substr(3,accountNumber.length-5),"0",13).trim();
  _controlNumber = accountNumber.substr(accountNumber.length-2,2);

  return mainThis.baseDataService.Get("Komitent","GetByZrc",[new QueryParameter('zrc', _bankCode+_accountNumber+_controlNumber)])
    .pipe(map((result =>{      
      if (result){
        komitentId = Number(result);
        return komitentId;
      }     
    })));
  
  }
  
  function GetCustomerTaxIDNOByAccountNumberFromNBS(accountNumber:string, mainThis:any):Observable<string>{
      // console.log('8. pronađi komitenta')
      let _bankCode : string;
      let _accountNumber : string;
      let _controlNumber: string;
      let _fullAccountNumber: string;
      let komitentPib: string;
      let komitentId: number;
      accountNumber = accountNumber.replace(/-/g,'');

      _bankCode = accountNumber.substr(0,3);
      _accountNumber = new CommonService().PadLeft(accountNumber.substr(3,accountNumber.length-5),"0",13).trim();
      _controlNumber = accountNumber.substr(accountNumber.length-2,2);
    
      return mainThis.companyDataService.GetCompanyDataByAccountNumber(_bankCode,_accountNumber,_controlNumber)
        // .subscribe((data: CompanyData[]) => {
            .pipe(map((data: CompanyData[]) =>{
              // console.log('9. pronašao komitenta')
              if(data[0] != undefined){
                komitentPib = data[0].TaxIdentificationNumber;
               
                return komitentPib;
              }
              else
                return of(komitentPib);
    
            }));

}

function GetCustomerIDByTaxIDNO(pib:string, mainThis:any):Observable<number>{
  let komitentId: number;

  return mainThis.baseDataService.Get("Komitent","GetByPib",[new QueryParameter('pib', pib)])
    .pipe(map((result =>{      
      if (result){
        komitentId = Number(result);
        return komitentId;
      }     
    })));
  
  }



